module.exports = __webpack_public_path__ + "../static/img/invalid_logo.11092e47.png";